import { formatNumber } from '../../../utils/format';

/* Les chiffres de l'écran : des francs qui suivent CHF · kCHF, des volumes dans l'unité affichée.
   Une cellule garde sa VALEUR brute (francs, unités de l'offre) ; `format` et `toDraft` la mettent en
   forme, `brute` ramène ce que l'on tape à la valeur stockée. */
export function makeFmt(unit) {
  const k = unit === 'kchf' ? 1000 : 1;
  const seuil = unit === 'kchf' ? 500 : 0.5;
  /* Un montant : « – » quand il tient pour rien ; jamais de décimale à l'affichage. */
  const val = (v) => (v == null || Math.abs(v) < seuil ? '–' : formatNumber(v / k, 0));
  /* En kCHF la saisie garde une décimale (179.1) pour ne pas arrondir ce qu'on retape. */
  const draft = (v) => (v == null ? '' : String(k === 1000 ? Math.round(v / 100) / 10 : Math.round(v)));
  const brut = (x) => (x == null ? null : Math.round(x * k * 100) / 100);
  const money = { aff: (x) => x, fmt: val, draft, brute: brut };
  /* Un volume : deux décimales au plus, sans les zéros. */
  const qte = (v) => {
    if (v == null) return '';
    if (Math.abs(v) < 0.005) return '–';
    const r = Math.round(v * 100) / 100;
    return formatNumber(r, Number.isInteger(r) ? 0 : Math.round(r * 10) / 10 === r ? 1 : 2);
  };
  /* L'unité de temps peut s'afficher dans l'autre (heures ⇄ jours-hommes) : `f` est le facteur affiché / stocké. */
  const volume = (f = 1) => ({
    aff: (x) => (x == null ? null : x * f), fmt: qte,
    draft: (x) => (x == null ? '' : String(Math.round(x * 100) / 100)),
    brute: (x) => (x == null ? null : Math.round((x / f) * 10000) / 10000),
  });
  /* Le PRIX UNITAIRE suit l'unité de l'écran comme tout le reste (demande d'Olivier, 2026-10-23) : en kCHF, 5'080 francs
     se lisent 5.08 ; trois décimales au plus, sans les zéros (168.75 francs : 0.169). `prix` prend des francs,
     `prixAff` les met dans l'unité affichée, `prixBrut` ramène ce qu'on tape en francs. */
  const decimales = (r) => [0, 1, 2, 3].find((d) => Math.abs(r - Number(r.toFixed(d))) < 1e-9) ?? 3;
  const prixLu = (v) => (v == null ? '' : formatNumber(v, k === 1000 ? decimales(Math.round(v * 1000) / 1000) : (Number.isInteger(Math.round(v * 100) / 100) ? 0 : 2)));
  const prixAff = (x) => (x == null ? null : Math.round((x / k) * 10000) / 10000);
  const prixBrut = (x) => (x == null ? null : Math.round(x * k * 100) / 100);
  const prix = (x) => prixLu(prixAff(x));
  return { k, val, draft, brut, money, qte, volume, prix, prixLu, prixAff, prixBrut };
}
